module.exports = __webpack_public_path__ + "img/index8.d59e45eb.png";